import request from '@/utils/request';

// 获取角色列表
export var getRoleList = function getRoleList(data) {
  return request({
    url: '/api/permission/Role',
    method: 'GET',
    data: data
  });
};

// 获取角色下拉框列表
export var getRoleSelector = function getRoleSelector() {
  return request({
    url: '/api/permission/Role/Selector',
    method: 'GET'
  });
};

// 新建角色
export var createRole = function createRole(data) {
  return request({
    url: '/api/permission/Role',
    method: 'POST',
    data: data
  });
};

// 修改角色
export var updateRole = function updateRole(data) {
  return request({
    url: "/api/permission/Role/".concat(data.id),
    method: 'PUT',
    data: data
  });
};

// 获取角色信息
export var getRoleInfo = function getRoleInfo(id) {
  return request({
    url: "/api/permission/Role/".concat(id),
    method: 'GET'
  });
};

// 删除角色
export var delRole = function delRole(id) {
  return request({
    url: "/api/permission/Role/".concat(id),
    method: 'DELETE'
  });
};

// 更新角色状态
export var updateRoleState = function updateRoleState(id) {
  return request({
    url: "/api/permission/Role/".concat(id, "/Actions/State"),
    method: 'PUT'
  });
};

// 获取角色类型
export var getRoleTypeSelector = function getRoleTypeSelector() {
  return request({
    url: '/api/system/DictionaryData/4501f6f26a384757bce12d4c4b03342c/Data/Selector',
    method: 'GET'
  });
};